package com.eladfinish.bible.contest.ui.animations

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale

/**
 * Returns a [Modifier] that plays a spring-bounce scale animation whenever
 * [trigger] changes to a truthy (non-null / non-false) value.
 *
 * The element scales from [initialScale] up to 1f with a medium-bouncy spring,
 * producing the same overshoot-and-settle feel as the legacy `R.anim.bounce`.
 */
@Composable
internal fun rememberBounceAnimation(
    trigger: Boolean,
    initialScale: Float = 0.1f,
): Modifier {
    var targetScale by remember { mutableFloatStateOf(if (trigger) 1f else initialScale) }

    LaunchedEffect(trigger) {
        targetScale = if (trigger) 1f else initialScale
    }

    val scale by animateFloatAsState(
        targetValue = targetScale,
        animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy,
            stiffness = Spring.StiffnessMediumLow,
        ),
    )

    return Modifier.scale(scale)
}
